import { getIntegrationAuthConfig } from './integrationAuth.util';
import type { RequestIdentitySnapshot } from './requestDedupeKey.util';

/**
 * Reads the current request identity from localStorage / integration env.
 * @returns Snapshot suitable for dedupe keys (not the bearer token itself)
 */
export function readRequestIdentitySnapshot(): RequestIdentitySnapshot {
  const integrationAuth = getIntegrationAuthConfig();
  return {
    impersonatedUserId: localStorage.getItem('impersonatedUserId'),
    language: localStorage.getItem('language'),
    integrationUserId: integrationAuth?.userId ?? null,
    integrationEmail: integrationAuth?.email ?? null,
  };
}
